import { temAcesso } from '@/shared/auth/temAcesso'

import comprometimentosRotas from './comprometimentos/ComprometimentosRotas'
import pagamentosRotas from './pagamentos/PagamentosRotas'
import requisicoesRotas from './requisicoes/RequisicoesRotas'
import comissionamentosRotas from './comissionamentos/comissionamentosRotas'
const Contratos = () => import('./Contratos.vue')
const ContratoDetalhar = () => import('./ContratoDetalhar.vue')
const ContratoAtualizarApostilar = () =>
    import('./ContratoAtualizarApostilar.vue')
const ContratoResponsavelForm = () =>
    import('./responsaveis/ContratoResponsavelForm.vue')
const PreContratoForm = () => import('./preContrato/PreContratoForm.vue')
const DadosRmForm = () => import('./dadosRM/dadosRMForm.vue')
const AditivarContrato = () => import('./aditivarContrato/AditivarContrato.vue')

export default {
    path: 'contratos',
    name: 'Contratos',
    component: Contratos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CONT-00')) {
            next()
        }
    },
    children: [
        {
            path: 'precontrato',
            name: 'Contratos_Inserir_Precontrato',
            component: PreContratoForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-PRE-00')) {
                    next()
                }
            }
        },
        {
            path: ':contratoId/editar',
            name: 'Contratos_Editar',
            component: PreContratoForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-PRE-01')) {
                    next()
                }
            }
        },
        {
            path: ':contratoId/detalhar',
            name: 'Contratos_Detalhar',
            component: ContratoDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-01')) {
                    next()
                }
            }
        },
        {
            path: ':contratoId/apostilar',
            name: 'Contratos_Apostilar',
            component: ContratoAtualizarApostilar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-APOST-01')) {
                    next()
                }
            }
        },
        {
            path: ':contratoId/atualizar',
            name: 'Contratos_Atualizar',
            component: ContratoAtualizarApostilar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-ELAB-00')) {
                    next()
                }
            }
        },
        {
            path: ':contratoId/atualizar',
            name: 'Contratos_Atualizar_Sem_Apostilar',
            component: ContratoAtualizarApostilar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-ATUALIZAR-00')) {
                    next()
                }
            }
        },
        {
            path: ':contratoId/atualizardadosrm',
            name: 'Contratos_Atualizar_DadosRM',
            component: DadosRmForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-ELAB-00')) {
                    next()
                }
            }
        },
        {
            path: ':contratoId/responsavel/:responsavelId',
            name: 'Contratos_Responsavel_Atualizar',
            component: ContratoResponsavelForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso(['CONT-APOST-03'])) {
                    next()
                }
            }
        },
        {
            path: ':contratoId/responsavel',
            name: 'Contratos_Responsavel_Inserir',
            component: ContratoResponsavelForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso(['CONT-APOST-03'])) {
                    next()
                }
            }
        },
        {
            path: ':contratoId/aditivarcontrato',
            name: 'Contratos_Aditivar',
            component: AditivarContrato,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-ELAB-00')) {
                    next()
                }
            }
        },
        pagamentosRotas,
        comprometimentosRotas,
        requisicoesRotas,
        comissionamentosRotas
    ]
}
